import React from "react";
import requestCall from "../requestCall";
import { encrypt, decrypt } from "../../utils/crypto";

import {
  VALIDATE_OTP_URL,
  SEND_OTP_URL,
  GET_METHOD,
  POST_METHOD,
} from "../apiConstants";

export const validateOTP = async (req) => {
  const baseData = {
    endPoint: VALIDATE_OTP_URL,
    method: POST_METHOD,
    headers: {
      //'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
  
  return requestCall(baseData, req);
};

export const sendEnteredOTP = async (req) => {
  const baseData = {
    endPoint: SEND_OTP_URL,
    method: POST_METHOD,
    headers: {
      //'Accept': 'application/json',
      "Content-Type": "application/json",
    },
  };

  
  console.log("REQ sendEnteredOTP", baseData,"---", req);


  return requestCall(baseData, req);;
};

// function changeRequestId(txnId){
//   var secret = '';
//   console.warn(JSON.stringify(requestIDs));
//   var latest = requestIDs.filter(function(val) {
//     console.log('val', val);
//     if (val.requestId === txnId) {
//       secret = val.secret.substring(0, val.secret.length - val.requestId.length);
//       return false;
//     }
//     return true;
//   });
//   setRequestIds(latest);
//   return secret;
// };

// let secret = generateSecreteKey(5);
//     let reqId = createRequestIds(requestId, secret);
//     let reqIds = requestIDs;
//     reqIds.push(reqId);
//     setRequestIds(reqIds);
//     console.log('reqId:' + reqId.requestId);
//     let payload = {
//       "mobileNo": "9545008309",
//       "otp":12346,
//       "txnId": reqId.requestId
//     };
//     let encrypted = encrypt(payload, secret);
//     console.log('encrypted:' + JSON.stringify(encrypted));
//     //let decrypted = decrypt();

//     fetch(
//       "http://127.0.0.1:8080/validateOtp", {
//       'body': JSON.stringify(encrypted),
//       'method': 'POST',
//       'headers': {
//         //'Accept': 'application/json',
//         'Content-Type': 'application/json'
//       }
//     })
//       .then((res) => res.json())
//       .then((json) => {
//         let DecryptedData;
//         let response = json;

//         var ENCRYPTED_KEY = changeRequestId(response.part2);
//         DecryptedData = decrypt(response.part1, ENCRYPTED_KEY);
//         console.log('DEcrypted dta', DecryptedData);

//         return;
//         let decrypted = decrypt(json.part1, json.part2);
//         console.warn("decrypted: " + decrypted);
//       });
